const APP = {
  MAJOR: 1,
  MINOR: 64,
  PATCH: 1,
}

const NATIVE = {
  MAJOR: 1,
  MINOR: 63,
  PATCH: 0,
}

/**
 * App version for all platforms and all releases
 *
 * Bump this on **all** app releases
 **/
const APP_VERSION = `${APP.MAJOR}.${APP.MINOR}.${APP.PATCH}`

/**
 * App version for native runtime
 *
 * Used by eas updates to determine if an update is compatible with native runtime
 *
 * Bump this only for **native** code releases
 **/
const NATIVE_VERSION = `${NATIVE.MAJOR}.${NATIVE.MINOR}.${NATIVE.PATCH}`

// eslint-disable-next-line no-undef
module.exports = {
  APP_VERSION,
  NATIVE_VERSION,
}
